import { useEffect } from "react";

type PlaceholderPageProps = {
  title: string;
  subtitle: string;
  backHref?: string;
};

export function PlaceholderPage({ title, subtitle, backHref = "/" }: PlaceholderPageProps) {
  useEffect(() => {
    document.title = `${title} | Yash Bindal`;
  }, [title]);

  return (
    <main className="container mx-auto flex min-h-screen max-w-2xl flex-col items-stretch justify-center gap-8 px-6 py-20">
      <div className="flex flex-col items-start gap-1">
        <h1 className="text-xl font-medium" style={{ color: "rgb(var(--text-primary))", fontFamily: "var(--font-serif)" }}>
          {title}
        </h1>
        <h4 className="font-light" style={{ color: "rgb(var(--text-secondary))" }}>
          {subtitle}
        </h4>
      </div>
      <a
        href={backHref}
        className="inline-flex w-fit items-center rounded-md px-3 py-2 text-sm font-medium transition-colors hover:underline"
        style={{
          color: "rgb(var(--text-primary))",
          border: "1px solid rgb(var(--border-color))",
          backgroundColor: "rgb(var(--bg-secondary))",
        }}
      >
        Back to home
      </a>
    </main>
  );
}
